import React from "react";

const SkeletonCard = () => {
  const shimmer = {
    background: "linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.3s infinite",
  };

  return (
    <div className="col-md-3 col-6 mb-3">
      <div className="p-3 rounded shadow-sm" style={{ height: 250 }}>
        <div style={{ height: 120, borderRadius: 6, ...shimmer }} />
        <div style={{ height: 15, marginTop: 20, ...shimmer }} />
        <div style={{ height: 15, marginTop: 10, width: "70%", ...shimmer }} />
        <div style={{ height: 15, marginTop: 20, width: "50%", ...shimmer }} />
      </div>
    </div>
  );
};

export default SkeletonCard;
